import { useReducer } from "react";

type TemplateVisibilityState = {
  attrValue: boolean;
  attrAttr: boolean;
  geometry: boolean;
};

const initialState: TemplateVisibilityState = {
  attrValue: false,
  attrAttr: false,
  geometry: false,
};

function reducer(state: TemplateVisibilityState, type: string) {
  return { ...state, [type]: !state[type] };
}

export const useToggleTemplate = () => {
  const [templateVisibility, toggleTemplate] = useReducer(reducer, initialState);

  return { templateVisibility, toggleTemplate };
};
